import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Href } from "../../../../Constants/Constants";

const Offset = () => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="up">
        <DropdownToggle caret color="secondary" className="light text-white">
          {"Offset"}
        </DropdownToggle>
        <DropdownMenu className="dropdown-block">
          <DropdownItem href={Href}>{"Action"}</DropdownItem>
          <DropdownItem href={Href}>{"Another action"}</DropdownItem>
          <DropdownItem href={Href}>{"Something else here"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};

export default Offset;
